module.exports = __webpack_public_path__ + "static/media/screen-right.eb5de2c9.webp";